import React, { Component } from 'react'
import { AgGridReact } from 'ag-grid-react';

export default class DetailsTable extends Component {
    constructor(props) {
        super(props);
        this.tableGrid = React.createRef();
    }
    onGridReady(){
        try {
            var allColumnIds = [];
            this.tableGrid.current.columnApi.getAllColumns().forEach(function(column) {
                allColumnIds.push(column.colId);
            });

            this.tableGrid.current.columnApi.autoSizeColumns(allColumnIds);
        } catch (error) {
        }
    }

    render() {
        return (
            <div style={{width:'100%',height:'150px'}}>
                <AgGridReact
                    enableRtl={true}
                    autoHeight={true}
                    animateRows={true}
                    enableCharts={true}
                    enableBrowserTooltips={true}
                    tooltipMouseTrack={true}
                    suppressSizeToFit={true}
                    columnDefs={this.props.columnDefs}
                    localeText={this.props.gridLocaleText}
                    rowData={this.props.data}
                    suppressDragLeaveHidesColumns ={true}
                    suppressMovable={true}
                    onGridReady={this.onGridReady.bind(this)}
                    multiSortKey='ctrl'
                    rowHeight={24}
                    headerHeight={35}
                    pagination={true}
                    paginationPageSize ={30}
                    suppressPaginationPanel={true}
                    ref={this.tableGrid}>
                </AgGridReact>
            </div>
            
        )
    }
}
